module.exports = __webpack_public_path__ + "static/media/siddharth-umbrella.a3ed8220.jpg";